// Custom error types
export class ApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public data?: any
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class AuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthError';
  }
}

// Development-only logger
export const logger = {
  log: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  error: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(...args);
    }
  },
  warn: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
};

// Error handler function
export const handleError = (error: unknown): string => {
  logger.error('Error occurred:', error);

  if (error instanceof ApiError) {
    return `API Error: ${error.message}`;
  }

  if (error instanceof AuthError) {
    return `Authentication Error: ${error.message}`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred';
};

// Type guard for checking if response is error
export const isErrorResponse = (
  response: any
): response is { error: string } => {
  return response && typeof response.error === 'string';
};
